module.exports = __webpack_public_path__ + "static/media/slider_img2.022f6d38.jpg";